/**
 * Upload expense receipt to Firebase Storage.
 * Path: expense_receipts/{expenseId}/{sanitizedFileName}
 */
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { getFirebaseStorage } from './firebase';

const STORAGE_PREFIX = 'expense_receipts';
const MAX_SIZE_BYTES = 10 * 1024 * 1024; // 10MB

function sanitizeFileName(name: string): string {
  return name.replace(/[^a-zA-Z0-9._-]/g, '_').slice(0, 120);
}

export async function uploadExpenseReceipt(expenseId: string, file: File): Promise<{ url: string; fileName: string }> {
  if (file.size > MAX_SIZE_BYTES) {
    throw new Error('Receipt file must be under 10MB');
  }
  const storage = getFirebaseStorage();
  const ext = file.name.includes('.') ? file.name.slice(file.name.lastIndexOf('.')) : '';
  const baseName = sanitizeFileName(file.name.replace(/\.[^.]+$/, '') || 'receipt');
  const fileName = `${baseName}${ext}`;
  const path = `${STORAGE_PREFIX}/${expenseId}/${fileName}`;
  const storageRef = ref(storage, path);
  await uploadBytes(storageRef, file, { contentType: file.type });
  const url = await getDownloadURL(storageRef);
  return { url, fileName };
}
